interface LoadingProps {
  message?: string;
}

function Loading({ message }: LoadingProps) {
  return (
    <div id='preloader'>
      <div id='loader'></div>
      {message && (
        <div style={{
          position: 'absolute',
          top: '60%',
          left: '50%',
          transform: 'translateX(-50%)',
          fontSize: '20px',
          color: '#ff8a00',
          fontFamily: 'ChanakyaUni'
        }}>
          {message}
        </div>
      )}
    </div>
  );
}

export default Loading;
